import React from 'react';
import PropTypes from 'prop-types';

import Page from 'components/Page';
import Button from 'components/Button';
import RadioList from 'components/RadioList';
import Footer from 'components/Footer';

import handleInputChange from 'utils/handleInputChange';
import {validate, isValidUSState, isValidUSZip} from 'utils/validations';

import './style.css';

/* eslint-disable max-len */
export class InterestInvestor extends React.Component {
  constructor() {
    super();

    // default props
    this.state = {
      investorType: 'person',
      investorCompany_type: 'LLC',
      investorLLC_type: 'P',
    };

    // handlers
    this.handleInputChange = handleInputChange.bind(this);
    this.validate = validate.bind(this);
    this.handlePageSubmit = this.handlePageSubmit.bind(this);
  }
  handlePageSubmit() {
    const s = this.state;
    const {investorType, investorName, investorSignatory} = s;

    const params = {
      name: investorName,
      street: s.investorAddressStreet,
      city: s.investorAddressCity,
      state: s.investorAddressState,
      zip: s.investorAddressZip,
    };

    // Reconstruct SSN or FEIN with dashes
    let taxId;
    if (investorType === 'person') {
      taxId = `${s.investorTaxId_S1}-${s.investorTaxId_S2}-${s.investorTaxId_S3}`;
    } else {
      taxId = `${s.investorTaxId_F1}-${s.investorTaxId_F2}`;
    }

    if (investorType === 'person') {
      params.type = 'Individual';
      params.ssn = taxId;
    } else if (investorType === 'trust') {
      params.signatory = investorSignatory;
      params.type = 'Trust';
      params.fein = taxId;
    } else if (investorType === 'company') {
      params.signatory = investorSignatory;
      params.type = s.investorCompany_type;
      if (s.investorCompany_type === 'LLC') {
        params.taxClassification = s.investorLLC_type;
      }
      params.fein = taxId;
    }

    // dispatch submit
    if (this.canSubmit()) {
      this.props.submit(params);
    }
  }
  canSubmit() {
    const s = this.state;
    const {investorType, investorName, investorSignatory} = s;

    // Validate Name
    const needsSignatory = (investorType === 'trust' || investorType === 'company');
    const validSignatory = (needsSignatory && investorSignatory) || !needsSignatory;

    const validName = investorName && validSignatory;

    // Validate SSN
    const needsSSN = investorType === 'person';
    const validSSN = s.investorTaxId_S1 &&
                     s.investorTaxId_S2 &&
                     s.investorTaxId_S3 &&
                     s.investorTaxId_S1.length === 3 &&
                     s.investorTaxId_S2.length === 2 &&
                     s.investorTaxId_S3.length === 4;

    // Validate FEIN
    const needsFEIN = (investorType === 'trust' || investorType === 'company');
    const validFEIN = s.investorTaxId_F1 &&
                      s.investorTaxId_F2 &&
                      s.investorTaxId_F1.length === 2 &&
                      s.investorTaxId_F2.length === 7;

    // Validate Tax Id
    const validTaxId = (needsSSN && validSSN) || (needsFEIN && validFEIN);

    // Validate address
    const addressFieldsSet = s.investorAddressStreet &&
                             s.investorAddressCity &&
                             s.investorAddressState &&
                             s.investorAddressZip;

    const validZip = isValidUSZip(s.investorAddressZip);
    const validState = isValidUSState(s.investorAddressState);

    const validAddress = addressFieldsSet && validState && validZip;

    // All conditions met?
    return validName && validTaxId && validAddress;
  }
  renderTaxIdInput() {
    const {investorType} = this.state;

    // if company or trust render FEIN input
    if (investorType === 'company' || investorType === 'trust') {
      return (
        <form styleName="taxId">
          <label styleName="formlabel" htmlFor="FEIN">FEIN:</label>
          <input type="number" name="investorTaxId_F1" onChange={this.handleInputChange} min="0" max="99" id="FEIN" placeholder="xx" data-test="investorTaxId_F1" />
          <span>-</span>
          <input type="number" name="investorTaxId_F2" onChange={this.handleInputChange} min="0" max="9999999" placeholder="xxxxxxx" data-test="investorTaxId_F2" />
        </form>
      );
    }

    // otherwise render SSN input
    return (
      <form styleName="taxId">
        <label styleName="formlabel" htmlFor="SSN">SSN:</label>
        <input type="number" name="investorTaxId_S1" onChange={this.handleInputChange} min="0" max="999" id="SSN" placeholder="xxx" data-test="investorTaxId_S1" />
        <span>-</span>
        <input type="number" name="investorTaxId_S2" onChange={this.handleInputChange} min="0" max="99" placeholder="xx" data-test="investorTaxId_S2" />
        <span>-</span>
        <input type="number" name="investorTaxId_S3" onChange={this.handleInputChange} min="0" max="9999" placeholder="xxxx" data-test="investorTaxId_S3" />
      </form>
    );
  }
  renderLLCType() {
    const {investorCompany_type} = this.state;

    // if company or trust render FEIN input
    if (investorCompany_type === 'LLC') {
      return (
        <form>
          <label styleName="formlabel" htmlFor="investorLLC_type">LLC Tax Classification:</label>
          <select onChange={this.handleInputChange} name="investorLLC_type" id="investorLLC_type" data-test="investorLLC_type">
            <option value="P">Partnership</option>
            <option value="C">C Corp</option>
            <option value="S">S Corp</option>
          </select>
        </form>
      );
    }
    return '';
  }
  renderCompanyDetails() {
    const {investorType} = this.state;

    // if company render type of company
    if (investorType === 'company') {
      return (
        <div>
          <form>
            <label styleName="formlabel" htmlFor="investorCompany_type">Company Type:</label>
            <select onChange={this.handleInputChange} name="investorCompany_type" id="investorCompany_type" data-test="investorCompany_type">
              <option value="LLC">LLC</option>
              <option value="CCorp">C Corp</option>
              <option value="SCorp">S Corp</option>
              <option value="Partnership">Partnership</option>
            </select>
          </form>
          {this.renderLLCType()}
        </div>
      );
    }
    return '';
  }
  renderSignatory() {
    const {investorType} = this.state;

    // if company or trust render FEIN input
    if (investorType === 'company' || investorType === 'trust') {
      return (
        <form>
          <label styleName="formlabel" htmlFor="investorSignatory">Natural Person Signing Legal Contracts:</label>
          <input type="text" id="investorSignatory" name="investorSignatory" onChange={this.handleInputChange} data-test="investor_signatory" />
        </form>
      );
    }
    return '';
  }
  render() {
    return (
      <section className="pageContainer">
        <Page>
          <h2>Investor Identification</h2>
          <p>I am investing as:</p>
          <RadioList>
            <p>
              <input type="radio" id="investorType_person" name="investorType" value="person" onChange={this.handleInputChange} defaultChecked />
              <label htmlFor="investorType_person">A Natural Person</label>
            </p>
            <p>
              <input type="radio" id="investorType_trust" name="investorType" value="trust" onChange={this.handleInputChange} />
              <label htmlFor="investorType_trust">A Trust</label>
            </p>
            <p>
              <input type="radio" id="investorType_company" name="investorType" value="company" onChange={this.handleInputChange} data-test="investor_company" />
              <label htmlFor="investorType_company">A Company</label>
            </p>
          </RadioList>
          {this.renderCompanyDetails()}
          <form>
            <label styleName="formlabel" htmlFor="investorName">Legal Name of Investing Entity:</label>
            <input type="text" id="investorName" name="investorName" onChange={this.handleInputChange} data-test="investor_name" />
          </form>
          {this.renderSignatory()}
          <form styleName="address">
            <label styleName="formlabel" htmlFor="investorAddressStreet">Address of Investing Entity:</label>
            <input type="text" placeholder="Address e.g. 123 Cool St, Apt 9A" id="investorAddressStreet" name="investorAddressStreet" onChange={this.handleInputChange} data-test="investorAddressStreet" />
            <input type="text" placeholder="City e.g. New York" id="investorAddressCity" name="investorAddressCity" onChange={this.handleInputChange} data-test="investorAddressCity" />
            <input type="text" placeholder="State e.g. NY" id="investorAddressState" name="investorAddressState" onChange={this.handleInputChange} data-test="investorAddressState" style={this.validate('investorAddressState', isValidUSState)} />
            <input type="text" placeholder="Zip e.g. 10001" id="investorAddressZip" name="investorAddressZip" onChange={this.handleInputChange} data-test="investorAddressZip" style={this.validate('investorAddressZip', isValidUSZip)} />
          </form>
          {this.renderTaxIdInput()}
          <div styleName="note">Note: The information you provide here will be used to complete a <a href="https://www.irs.gov/pub/irs-pdf/fw9.pdf" target="_blank" rel="noopener noreferrer"><strong>W-9</strong></a> form. You will be asked to certify it as accurate, under penalty of perjury.</div>
          <Footer>
            <Button onClick={this.handlePageSubmit} disabled={!this.canSubmit()} data-test="investor_submit">
              Continue
            </Button>
          </Footer>
        </Page>
      </section>
    );
  }
}
/* eslint-enable max-len */

InterestInvestor.propTypes = {
  submit: PropTypes.func.isRequired,
};

export default InterestInvestor;



// WEBPACK FOOTER //
// ./web/flows/interest/investor/component.js